/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Interest_ExpressedInputs */

const cs_enum_interest_expressed = /** @type {(inputs: Enum_Interest_ExpressedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zájem projeven`)
};

const en_enum_interest_expressed = /** @type {(inputs: Enum_Interest_ExpressedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interest expressed`)
};

/**
* | output |
* | --- |
* | "Interest expressed" |
*
* @param {Enum_Interest_ExpressedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_interest_expressed = /** @type {((inputs?: Enum_Interest_ExpressedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Interest_ExpressedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_interest_expressed(inputs)
	return cs_enum_interest_expressed(inputs)
});